import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {PermissionContainerModel} from '../../../../../models/aggregates/permissions';
import {ApiVisa, PagingResponseModel} from '../shared';
import {Observable} from 'rxjs';

export class RequestBody {
  calcTotalRecords: string;
  search_word?: string;
  offset?: number;
  limit?: number;
}

@Injectable({
  providedIn: 'root'
})
export class PermissionDefinitionsService extends BaseApiTemplateService<PermissionContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_MICRO_SERVICES_URL_PREFIX + 'permissions';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_MICRO_SERVICES_URL_PREFIX + 'permissions';
    this.endpoint_path = Core2Config.PLATFORM_MICRO_SERVICES_URL_PREFIX + 'permissions';
    this.httpClient = http;
  }

  getPermDfn(body: RequestBody, visa: ApiVisa): Observable<PagingResponseModel<PermissionContainerModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_MICRO_SERVICES_URL_PREFIX + 'permissions/query';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.PLATFORM_MICRO_SERVICES_URL_PREFIX + 'permissions/query';
    }
    return this.httpClient.post<PagingResponseModel<PermissionContainerModel>>(url, body, this.getHttpHeader(visa));
  }
}


